export default "__VITE_ASSET__ccbe131e__"